import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Pagination from "react-js-pagination";
import { apiUrl } from "../Config/Config";
import axios from "axios";
import $ from "jquery";
import { lang } from "../Helpers/lang";
import moment from "moment";

import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button,
} from "react-bootstrap";
import Header from "../Layouts/Header";
import MenuSidebar from "../Layouts/MenuSidebar";
import { baseUrl } from "../Config/Config";

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      joblists: [],
      activePage: 1,
      totalRecord: "",
      search_all: "",
      selectedStatus: "",
      selectid: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentDidMount() {
    this.listloadedData();
  }

  listloadedData(postobject = "") {
    var qs = require("qs");
    if (postobject != "") {
      var postobject = postobject;
    } else {
      var postobject = {
        activePage: this.state.activePage,
        search_all: "",
        admin_id: localStorage.getItem("admin_id"),
      };
    }

    axios
    .post(apiUrl + "adminpanel/new_lead_list", qs.stringify(postobject))
    .then((res) => {
      if (res.data.status === "success") {
        const responseData = res.data.response;
        const count = res.data.count;

        this.setState(
          {
            joblists: responseData ? responseData : [],
            totalRecord: count,
          },
          () => {
            if (count > 0) {
              this.joblist();
            } else {
              console.log("No records found.");
            }
          }
        );
      }
    })
    .catch((error) => {
      console.log("API error:", error);
    });
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber });
    var qs = require("qs");
    var postobject = {
      activePage: pageNumber,
      search_all: this.state.search_all,
      admin_id: localStorage.getItem("admin_id"),
    };
    this.listloadedData(postobject);
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    var postObject = {
      activePage: this.state.activePage,
      search_all: value,
      admin_id: localStorage.getItem("admin_id"),
    };
    this.setState(
      {
        [name]: value,
      },
      function () {
        this.listloadedData(postObject);
      }
    );
  }
  handleFormSubmit = () => {
    this.setState({ Loading: true });
    var qs = require("qs");
    const formPayload = this.state;

    var postObject = {
      activePage: this.state.activePage,
      search_all: this.state.search_all,
      admin_id: localStorage.getItem("admin_id"),
    };
    this.listloadedData(postObject);
  };

  componentWillReceiveProps(Props) {}

  activateuser() {
    let stat = "";
    if (this.state.selectedStatus === "inactive") {
      stat = "I";
    } else {
      stat = "A";
    }

    var qs = require("qs");
    var postObject = {
      admin_id: localStorage.getItem("admin_id"),
      job_id: this.state.selectid,
      job_status: stat,
    };
    axios
      .post(apiUrl + "adminpanel/job_change_status", qs.stringify(postObject))
      .then((res) => {
        if (res.data.status === "success") {
          this.listloadedData();
          $(".success_message").html(
            '<div class="status_sucess"><h3>' + res.data.message + "</h3></div>"
          );
          setTimeout(
            function () {
              $(".success_message").html("");
            }.bind(this),
            3000
          );
        }
      });
  }

  confirmPopup = (id, status) => {
    var status = status;
    if (status == "inactive") {
      status = "active";
    } else {
      status = "inactive";
    }
    this.setState({ selectid: id, selectedStatus: status });
    $(".confirm-action").addClass("show");
  };

  Confirmstatus = (confirmstatus) => {
    if (confirmstatus == "yes") {
      this.activateuser();
      $(".confirm-action").removeClass("show");
    } else {
      $(".confirm-action").removeClass("show");
    }
  };
  exportdata() {
    let stat = "";
    var qs = require("qs");
    var postObject = {
      admin_id: localStorage.getItem("admin_id"),
    };
    axios
      .post(apiUrl + "contractors/export", qs.stringify(postObject))
      .then((res) => {
        if (res.data.status === "success") {
          var url = res.data.url;
          var cleanurl = url.replace(/([^:]\/)\/+/g, "$1");
          window.open(cleanurl, "_blank", "noreferrer");
          // window.location.reload();
        }
      });
  }
  joblist() {
  const joblist = this.state.joblists;

  if (joblist && joblist.length > 0) {
    return joblist.map((data, index) => {
      const sno = index + 1;
      const status = data.status === "A" ? "active" : "inactive";

      return (
        <tr key={data.id}>
          <td>{sno}</td>
          <td>{data.constructionCode}</td>
          <td>{data.constructionName}</td>
          <td>
            {data.created_on
              ? moment(data.created_on).format("MM/DD/YYYY, h:mm A")
              : "N/A"}
          </td>
          <td className="actiongroup">
            {/* <Link
              to={{ pathname: "/project-view/" + data.id }}
              title="View"
            >
              <i className="ft-eye" aria-hidden="true"></i>
            </Link> */}
            {status === "active" ? (
              <Link
                onClick={() => this.confirmPopup(data.id, status)}
                title="Status"
              >
                <i className="ft-unlock" aria-hidden="true"></i>
              </Link>
            ) : (
              <Link
                onClick={() => this.confirmPopup(data.id, status)}
                title="Status"
              >
                <i className="ft-lock" aria-hidden="true"></i>
              </Link>
            )}
          </td>
        </tr>
      );
    });
  } else {
    return (
      <tr>
        <td colSpan="5" className="v-align-nr text-center">
          No Result
        </td>
      </tr>
    );
  }
}


  render() {
    return (
      <div className="wrapper">
        <div className="confirm-action">
          <p>
            Are you sure you want to {this.state.selectedStatus} the
            job?
          </p>
          <a
            href="javascript://"
            onClick={this.Confirmstatus.bind(this, "yes")}
            className="btn"
          >
            Yes
          </a>
          <a
            href="javascript://"
            onClick={this.Confirmstatus.bind(this, "no")}
            className="btn"
          >
            No
          </a>
        </div>
        <Header />
        <MenuSidebar currentpage="job" />

        <div className="content">
          <div className="content-wrapper">
            <div class="content-wrapper-before"></div>
            <div className="car-listing-wrap leaa-admin-head card">
              <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>
                    {this.state.totalRecord} Job
                    {this.state.totalRecord > 1 ? "s" : ""}
                  </h3>
                </div>
                <div className="search-list">
                  <form
                    className="edit"
                    id="edit"
                    onSubmit={(e) => {
                      this.handleFormSubmit(this);
                      e.preventDefault();
                    }}
                  >
                    <div className="search-inner">
                      <input
                        type="text"
                        name="search_all"
                        onChange={this.handleInputChange}
                        className="form-control"
                        value={this.state.search_all}
                        placeholder="Search"
                      />
                      <button className="" type="submit">
                        Submit
                      </button>
                      <div className="erroremail"></div>
                    </div>
                  </form>
                </div>
              </div>

              <div className="car-listing-row">
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Job ID</th>
                      <th>Job Name</th>
                      <th>Register On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>{this.joblist()}</tbody>
                </Table>
                <div className="text-center">
                  <Pagination
                    activePage={this.state.activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.totalRecord}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;
